export const GET_ANALYSIS_DATA = '/analysis-information-for-order';
export const GET_DOWNLOAD_DATA = '/download-stl-file';
export const GET_FAQ_CMS = 'faq-dashboard';
export const GET_VIDEO_TUTORIALS = 'video-tutorials';
export const GET_COMPANIES = '/companies';
export const GET_ACTIVE_COMPANIES = '/companies?active=001&mowaId[$ne]=null';
export const GET_ALL_ORDERS = '/orders?type=normalOrder';
export const GET_ALL_PROPOSALS = '/orders?type=approvalRequired';
export const GET_PENDING_PROPOSALS = '/pending-proposals';
export const GET_PROPOSAL = '/orders?magentoCartId=';
export const GET_QUIZES = '/quizes';
export const GET_LOGIN = '/authentication';
export const GET_USERS = '/users';
export const GET_APPROVED_USERS = '/users?awaitingActivation=000';
export const GET_WAITING_REGISTRATION_USERS =
  '/users?awaitingActivation=001&requestForCompanyName[$ne]=null';
export const GET_COMPANY_USERS = '/users?companyId=';
export const GET_FORGOT_PW_EMAIL_USERS = '/resend-activation-email';
export const GET_USERS_BY_EMAIL = '/users?email=';

export const STORE_DATA_FOR_MINUTES = 30;

export const STORAGE_TOKEN_USER_TOKEN = 'USER_TOKEN';
export const STORAGE_USER = 'CURRENT_USER';
